import React from "react";
import {
  CheckCircle2,
  Award,
  ShieldCheck,
  Tag,
  Truck,
  Package,
} from "lucide-react";

const WhyChooseUs = () => {
  const items = [
    { title: "Certified organic dehydrated powders", icon: <CheckCircle2 /> },
    { title: "Premium quality groceries", icon: <Award /> },
    { title: "Export quality assurance", icon: <ShieldCheck /> },
    { title: "Competitive pricing", icon: <Tag /> },
    { title: "Reliable global shipping", icon: <Truck /> },
    { title: "Flexible packaging options", icon: <Package /> },
  ];

  return (
    <section className="py-16 md:py-24 bg-slate-50 border-y border-slate-200">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-primary mb-4 tracking-tight uppercase">
            Why Choose Us?
          </h2>
          <div className="w-16 md:w-20 h-1 bg-accent mx-auto"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 md:gap-5 p-5 md:p-6 bg-white rounded-xl md:rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow"
            >
              <div className="text-accent shrink-0">
                {React.cloneElement(item.icon, { size: 28 })}
              </div>
              <span className="text-base md:text-lg font-bold text-primary leading-tight">
                {item.title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
